<template>
    <div>
      <b-table
        :items="items"
        :fields="fields"
        class="table-transition"
        primary-key="number"
        :tbody-transition-props="transProps"
        table-busy :busy="loading"
        sort-icon-left borderless striped hover responsive>

          <template #cell(balance_or_vw)="data">
            {{getIsBalanceSheetText(data.item)}}
          </template>

          <template #table-busy="">
            <b-skeleton-table :rows="8" :columns="4" :table-props="{ bordered: false }" :hide-header="true" />
          </template>
      </b-table>
    </div>
  </template>
  <script>
  import CostTypeGroupService from '@/store/services/costtypegroup.service';
  
  export default {
      name: "LedgerCategoriesTable",
      data() {
        return {
          items: [],
          fields: [
            {key: "number", label: this.$gettext("NUMBER"), sortable: true},
            {key: "name", label: this.$gettext("NAME")},
            {key: "balance_or_vw", label: this.$gettext("BALANCE/P&L")},
            {key: "category", label: this.$gettext("CATEGORY")}
          ],
          transProps: {
              name: 'flip-list'
          },
          loading: true
        }
      },
      created() {
        CostTypeGroupService.list().then((response) => {
          this.items = response.data;
          this.loading = false;
        });
      },
      methods: {
        getIsBalanceSheetText(item) {
          if (item.balance_or_vw === "profit") return this.$gettext("Profit");
          else if (item.balance_or_vw === "balance") return this.$gettext("Balance");
        }
      }
  }
  </script>
  <style>
  table.table-transition .flip-list-move {
    transition: transform 0.3s;
  }
  </style>